export default function FormStepper({ currentStep }) {
    const steps = [
      'Personal Information',
      'Employment History',
      'Educational Details',
      'Additional Information',
    ];
  
    return (
      <div className="flex justify-between items-center border-b border-gray-200 mb-6 max-w-4xl mx-auto">
        {steps.map((label, index) => {
          const step = index + 1;
          const isActive = currentStep === step;
          return (
            <div key={index} className="flex flex-col items-center flex-1">
              <div
                className={`w-8 h-8 rounded-full border-2 flex items-center justify-center font-bold text-sm ${
                  isActive ? 'bg-primary text-white border-primary' : 'border-gray-300 text-gray-500'
                }`}
              >
                {step}
              </div>
              <p
                className={`text-xs mt-1 text-center ${
                  isActive ? 'text-primary font-semibold' : 'text-gray-500'
                }`}
              >
                {label.split(' ')[0]}
                <br />
                <span className="text-[11px] font-light">{label.split(' ').slice(1).join(' ')}</span>
              </p>
            </div>
          );
        })}
      </div>
    );
  }
  